import { useState, useEffect } from 'react';
import FloatingLoading from '../../PopUpModal/ModalVersions/FloatingLoading/FloatingLoading';
import { getAuth } from "firebase/auth";
import { useAtom } from "jotai";
import { useHistory } from 'react-router-dom';
import dataBase from '../../../config';
import { Link } from 'react-router-dom';
import { FcPicture } from 'react-icons/fc';
import { GiConfirmed } from 'react-icons/gi';
import { BsFillMenuButtonWideFill } from 'react-icons/bs';
import { ImBlocked } from 'react-icons/im';
import { getDatabase, ref as UserPanelRef, child, get, onValue} from "firebase/database";
import { useMainFilter, useLoggedUser, useDownloadedOffers, useShowPopUpModal, useModalVersion, useModalInfo, useExpiredOffers, useAwaitOffer, useShowLoadingAnim } from "../../../data/GlobalStates";
import UserOfferDisplayCard from '../UserOfferDisplayCard/UserOfferDisplayCard';

const CompanyView = ({refresh, setCountryFilterCode, setRefresh}) => {

  const ActualDate = Date.now();
  const authedUser = getAuth() //authedUser.currentUser
  const dbRef = UserPanelRef(dataBase);// UCHW DO ODCZYTU
  const history = useHistory();

  //stany globalne:
  const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
  const [ DownloadedOffers, setDownloadedOffers ] = useAtom(useDownloadedOffers);
  const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
  const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
  const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);
  const [ ExpiredOffers, setExpiredOffers] = useAtom(useExpiredOffers);
  const [ AwaitOffer, setAwaitOffer ] = useAtom(useAwaitOffer);
  const [ ShowLoadingAnim, setShowLoadingAnim ] = useAtom(useShowLoadingAnim);
  const [ MainFilter, setMainFilter ] = useAtom(useMainFilter);

  //stany lokalne:
  const [UserOffers, setUserOffers] = useState('')
  const [AwaitingOffers, setAwaitingOffers] = useState('')
  const [UserOffersDisplayType, setUserOffersDisplayType] = useState(1)

  useEffect(() => {

    let isMounted = true;

    if (authedUser.currentUser && DownloadedOffers.length && isMounted) {
      syncActiveOffers()
      syncExpiredOffers()

      const db = getDatabase() // do przeniesienia
      const response = UserPanelRef(db, 'offers')
      return onValue(response, (snap) => {
        if (snap.exists()) {
          const data = snap.val() // obiekt zagnieżdzonych obiektów
          setAwaitingOffers(Object.values(data).filter(offer => offer.companyName === LoggedUser.name && offer.visibility === false && offer.paid === false).sort((a, b) => (b.addDate - a.addDate)))
        }
      })
    }
    return () => {
      isMounted = false;
    };
  },[ authedUser.currentUser, DownloadedOffers.length, LoggedUser, refresh])

 

const syncExpiredOffers = async () => {
  await get(child(dbRef, `offers`)).then((awaitingOffers) => {
    setExpiredOffers(Object.values(awaitingOffers.val()).filter(offer => offer.companyName === LoggedUser.name && offer.visibility === false))})
};

const syncActiveOffers = async () => {
  await get(child(dbRef, `offers`)).then((awaitingOffers) => {
    setUserOffers(Object.values(awaitingOffers.val()).filter(offer => offer.companyName === LoggedUser.name && offer.visibility === true))})
};


  const OpenChooseDataToEditModal = () => {
    setShowPopUpModal(true)
    setModalVersion(26)
    setModalInfo({title: 'Wybierz dane do edycji:'})
  };

  const OpenLogoUploader = () => {
    setShowPopUpModal(true)
    setModalVersion(17)
  };


      const setOfferToActivate = (offer) => {
        history.push({pathname: `/userPanel/OfferToActivate/${offer.id}`}) 
        setAwaitOffer(offer)
        setShowPopUpModal(true)
        setModalVersion(23)
        setModalInfo({title: 'Aktywować Ogłoszenie ?'})
        window.scrollTo(0,0)
      }

      const setActiovationMessage = (match) => {
        setShowPopUpModal(true)
        setModalVersion(2)
        setModalInfo({title: 'Nie znaleziono oferty', message: match[1]})
        window.scrollTo(0,0)
        history.push({pathname: `/userPanel`}) 
      };

    useEffect(() => {
       const path = history.location.pathname;
       const match = path.match(/^\/userPanel\/OfferToActivate\/(.+)$/);

      if (!AwaitOffer && match && ExpiredOffers && ExpiredOffers.length > 0 && history.location.pathname) {
        const offerId = match[1];
        const foundOffer = ExpiredOffers.find((offer) => offer.id === offerId);

        if (foundOffer) {
         setOfferToActivate(foundOffer);
       } else {
         setActiovationMessage(match);
       }
  }
}, [AwaitOffer, history.location.pathname, ExpiredOffers]); 


const showUserOffers = () => {
  if (UserOffersDisplayType === 1) {
    return (
      UserOffers.length ? 
      UserOffers
     .filter(offer => MainFilter === '' || offer.MainCategory === MainFilter)
     .map(offer => (
       <UserOfferDisplayCard
         key={offer.id}
         offer={offer}
         setModalVersion={setModalVersion}
         UserOffersDisplayType={UserOffersDisplayType}
         setCountryFilterCode={setCountryFilterCode}
         setUserOffersDisplayType={setUserOffersDisplayType}
         />
        )) :
           <div className='UserPanelNoOfferInfoAndAddButton'>
              <h1 className='EndedOffersInfoHeader'>Nie masz aktywnych ofert</h1>
                  <Link to='/DodajNews' className='UserPanelAddButtons'>
                    Dodaj News
                  </Link>
           </div>
    )
  } else if (UserOffersDisplayType === 4) { // Zakończone oferty
    const filteredExpiredOffers = ExpiredOffers.filter(
      offer => MainFilter === '' || offer.MainCategory === MainFilter
    );

    return (
      <div className='EndedUserOffersMainContainer'> 

        {filteredExpiredOffers.length > 0 ? (
          <div>
            {filteredExpiredOffers.map(offer => (
              <UserOfferDisplayCard
                key={offer.id}
                offer={offer}
                UserOffersDisplayType={UserOffersDisplayType}
                setUserOffersDisplayType={setUserOffersDisplayType}
              />
            ))}
          </div>
        ) : (
          <div className='UserPanelNoOfferInfoAndAddButton'>
            {MainFilter !== '' ? (
              <h1 className='EndedOffersInfoHeader'>
                Brak zakończonych ofert w kategorii <strong>{MainFilter}</strong>
              </h1>
            ) : (
              <>
                <h1 className='EndedOffersInfoHeader'>
                  Zakończone oferty będą widoczne i dostępne do aktywacji przez 30 dni
                </h1>
                <Link to='/DodajOgłoszenie' className='UserPanelAddButtons'>Dodaj Ogłoszenie</Link>
              </>
            )}
          </div>
        )}

      </div>
    )
  }
};


  const switchUserOfferDisplayType = (type) => {
    setUserOffersDisplayType(type)
    setRefresh(Math.floor(Math.random() * 30))
  };


  const ShowDescription = () => {
    return(
         <p id='descriptionField' className='AdressFields'>{ LoggedUser.Description ? LoggedUser.Description.slice(0, 10) + '...' : <span className='AdressFieldsPlaceHolder'>uzupełnij opis</span>}</p>
    )
  };



    const ShowLogoEditor = () => {
    return(
      <>
       <div id='EmailInfo'>
         <p id='emailTitle'>Zdjęcie:</p>
       </div> 
       { LoggedUser.UserLogo ? <img src={LoggedUser.MiniLogoUrl} className='UserLogoUserPanel'></img> : <FcPicture className='UserLogoUserPanel' onClick={OpenLogoUploader}/>}
      </>
    )
  }


  return (
    <div id='LoggedUserMainDiv'>
    <div id='UserProfileInfoDiv'>
       { ShowLoadingAnim ? <FloatingLoading/> : null }


           <div id='CompanyNameInfo'>
              <h2 id='displayedCompanyName'>{LoggedUser.name}</h2>
           </div>

       { LoggedUser.AccountType == 'Company' ?  ShowLogoEditor() : null }


               <div id='EmailInfo'>
                  <p id='emailTitle'>E-mail:</p>
                  <p id='emailValue'>{LoggedUser.email}</p>
               </div>
                  
                      <div className='EditBtns' onClick={OpenChooseDataToEditModal}>
                        <p>Edytuj Dane</p>
                        <BsFillMenuButtonWideFill className='EditUserDataIcon'/>
                      </div>

    </div>
    <div id='UserDataDiv'>
      <div className='TitleAndValueContainer' onClick={OpenChooseDataToEditModal}>
        <h3 className='Titles'>Nr. kontaktowy: </h3>
        <p id='phoneValue' className='AdressFields'>{LoggedUser.PhoneNumber}</p>
      </div>

      <div className='TitleAndValueContainer' onClick={OpenChooseDataToEditModal}>
         <h3 className='Titles'>Adres: {LoggedUser.Adress}</h3>
         <div id='AdressValues'>
                       <p className='AdressFields'>{LoggedUser.City ? LoggedUser.City : <span className='AdressFieldsPlaceHolder'>miasto</span>}</p>
                       <p className='AdressFields'>{LoggedUser.Street ? LoggedUser.Street : <span className='AdressFieldsPlaceHolder'>ulica</span>} {LoggedUser.BuildingNr ? LoggedUser.BuildingNr : <span className='AdressFieldsPlaceHolder'>nr. bud.</span>} / {LoggedUser.LocalNr ? LoggedUser.LocalNr : <span className='AdressFieldsPlaceHolder'>nr. lokalu</span>}</p>
                       <p className='AdressFields'>{LoggedUser.ZipCode ? LoggedUser.ZipCode : <span className='AdressFieldsPlaceHolder'>kod pocztowy</span>}</p>
         </div>
      </div>

      </div>
      <div id='UserOffersDiv'>
        <h1 className='Titles'>Twoje Newsy:</h1>
        <div id='UserOffersTypeHeader'>
          <h1 className={UserOffersDisplayType === 1 ? 'UserOffersHeaderActive' : 'UserOffersHeader'} onClick={() => switchUserOfferDisplayType(1)}>Aktywne: {UserOffers.length}</h1>
          <h1 className={UserOffersDisplayType === 4 ? 'UserOffersHeaderActive' : 'UserOffersHeader'} onClick={() => switchUserOfferDisplayType(4)}>Zakończone: {ExpiredOffers.length}</h1>
        </div>
        
        <div className='UserPanelMainCatFilters'>
  
        </div>

        <div id='MyOffersDisplay'>
          {
            showUserOffers()
          }
        </div>
    </div>
  </div>
  )
}

export default CompanyView;